import React from "react";
import {
  Inbox,
  Clock,
  RotateCw,
  CheckCircle2,
  LifeBuoy,
} from "lucide-react";

export default function TeacherSupportMiniDashboard({
  stats = {},
  activeStatus = "all",
  onSelectStatus = () => {},
}) {
  const cards = [
    {
      key: "all",
      label: "Tổng phiếu tiếp nhận",
      shortLabel: "Tổng phiếu",
      value: stats.total || 0,
      icon: Inbox,
      tone: "slate",
      borderClass: "border-slate-300",
      bgClass: "bg-gradient-to-br from-slate-200 via-slate-100 to-slate-50",
      blobClass: "bg-slate-400/55",
      watermarkClass: "text-slate-600/30",
      textClass: "text-slate-900",
      labelClass: "text-slate-800",
      iconWrapClass: "border border-slate-300 bg-white text-slate-800 shadow-sm",
      activeRing: "ring-2 ring-slate-400/90 shadow-md",
    },
    {
      key: "open",
      label: "Đã gửi (Chờ xử lý)",
      shortLabel: "Chờ xử lý",
      value: stats.open || 0,
      icon: Clock,
      tone: "amber",
      borderClass: "border-amber-300",
      bgClass: "bg-gradient-to-br from-amber-200 via-amber-100 to-orange-50",
      blobClass: "bg-amber-400/55",
      watermarkClass: "text-amber-600/35",
      textClass: "text-amber-900",
      labelClass: "text-amber-800",
      iconWrapClass: "border border-amber-300 bg-white text-amber-800 shadow-sm",
      activeRing: "ring-2 ring-amber-400/90 shadow-md",
    },
    {
      key: "in_progress",
      label: "Đang xử lý",
      shortLabel: "Đang xử lý",
      value: stats.in_progress || 0,
      icon: RotateCw,
      tone: "sky",
      borderClass: "border-sky-300",
      bgClass: "bg-gradient-to-br from-sky-200 via-sky-100 to-blue-50",
      blobClass: "bg-sky-400/55",
      watermarkClass: "text-sky-600/35",
      textClass: "text-sky-900",
      labelClass: "text-sky-800",
      iconWrapClass: "border border-sky-300 bg-white text-sky-800 shadow-sm",
      activeRing: "ring-2 ring-sky-400/90 shadow-md",
    },
    {
      key: "resolved",
      label: "Đã xử lý & Phản hồi",
      shortLabel: "Đã xử lý",
      value: stats.resolved || 0,
      icon: CheckCircle2,
      tone: "emerald",
      borderClass: "border-emerald-300",
      bgClass: "bg-gradient-to-br from-emerald-200 via-emerald-100 to-teal-50",
      blobClass: "bg-emerald-400/55",
      watermarkClass: "text-emerald-600/35",
      textClass: "text-emerald-900",
      labelClass: "text-emerald-800",
      iconWrapClass: "border border-emerald-300 bg-white text-emerald-800 shadow-sm",
      activeRing: "ring-2 ring-emerald-400/90 shadow-md",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4 mb-6">
      {cards.map((card) => {
        const Icon = card.icon;
        const isActive = activeStatus === card.key;

        return (
          <button
            key={card.key}
            type="button"
            onClick={() => onSelectStatus(card.key)}
            className={`relative overflow-hidden rounded-2xl border p-4 text-left shadow-sm transition-all duration-200 hover:scale-[1.01] active:scale-[0.99] ${
              card.borderClass
            } ${card.bgClass} ${isActive ? card.activeRing : ""}`}
          >
            {/* Soft decorative blob */}
            <div
              aria-hidden
              className={`pointer-events-none absolute -right-8 -top-10 h-28 w-28 rounded-full blur-2xl ${card.blobClass}`}
            />

            {/* Watermark icon */}
            <Icon
              aria-hidden
              className={`pointer-events-none absolute -bottom-3 -right-2 h-24 w-24 ${card.watermarkClass}`}
              strokeWidth={1.25}
            />

            <div className="relative z-10 flex flex-col justify-between h-full">
              <div className="flex items-start justify-between gap-2">
                <p className={`text-[11px] font-bold uppercase tracking-wider ${card.labelClass}`}>
                  <span className="hidden sm:inline">{card.label}</span>
                  <span className="sm:hidden">{card.shortLabel}</span>
                </p>
                <div className={`rounded-xl p-2 ${card.iconWrapClass}`}>
                  <Icon className="h-4 w-4" />
                </div>
              </div>

              <div className="mt-3">
                <p className={`text-2xl sm:text-3xl font-black tabular-nums tracking-tight ${card.textClass}`}>
                  {Number(card.value).toLocaleString("vi-VN")}
                </p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
